/* unplugin-vue-components disabled */import script from "./PropsSpinner.vue?vue&type=script&setup=true&lang=js"
export * from "./PropsSpinner.vue?vue&type=script&setup=true&lang=js"

import "./PropsSpinner.vue?vue&type=style&index=0&id=00188c2c&scoped=true&lang=less"

import exportComponent from "/Users/zhangxuan/Documents/Projects/VinesDjango/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-00188c2c"]])

export default __exports__